import { Route, Routes } from 'react-router-dom';
import { NotFound, ShippingOrderQuery } from '@pages';
import { Protected } from '@components';

function RoutesShippingOrders() {
  return (
    <Protected>
      <Routes>
        <Route index element={<ShippingOrderQuery />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Protected>
  );
}

export default RoutesShippingOrders;
